module.exports = __webpack_public_path__ + "fe06bd3c7bed9a33e552d1f7cb136831.MP3";